<template lang="html">
  <div class="change" v-if='changeLg'>
    <div class="titleBloc d-flex flex-column justify-content-center">
      <div class="title">{{ $tlang(lg1, 'mercure.rates.rightTitles.change') }}***</div>
      <div class="subtitle">{{ $tlang(lg2, 'mercure.rates.rightTitles.change') }}***</div>
    </div>
    <div>
      <div v-for="change in filteredChange" class="rowChange d-flex flex-row justify-content-between align-items-center">
        <img class="flag" :src="getFlag(change.mer_moneyflag)"></img>
        <span class='price'>{{ change.mer_value }}</span>
      </div>
    </div>
    <div class="subtitles">
      <p class="lg1" v-if="changeLg.lg1.subtitle">{{ changeLg.lg1.subtitle }}</p>
      <p class="lg2" v-if="changeLg.lg2.subtitle">{{ changeLg.lg2.subtitle }}</p>
    </div>
  </div>
</template>

<script lang="js">
  var take = require('lodash/take')

  export default {
    name: 'change',
    props: ['changeLg'],
    mounted () {

    },
    data () {
      return {

      }
    },
    methods: {
      getFlag (flagName) {
        return `/static/mercure/change/flags/mercure_flag_${flagName}`
      }
    },
    computed: {
      lg1 () {
        return this.$store.getters.site.get('rates').get('data').languages[0].name.toLowerCase()
      },
      lg2 () {
        return this.$store.getters.site.get('rates').get('data').languages[1].name.toLowerCase()
      },
      filteredChange () {
        return take(this.changeLg.lg1.rates, 8)
      }
    }
}
</script>

<style scoped lang="scss">
$srcWidth: 1920;
$srcHeight: 1080;
@import "../../../../../_novotel.scss";

.change {
  padding-top: 4.1vh;
  height: 100%;
  // position: relative;

  .rowChange {
    width: 100%;
    @include heightPercent(65.3);
    border-top: 1px solid $purple;
    color: $purple;
    font-family: "HouschkaAltPro-Medium";
    &:last-child {
      border-bottom: 1px solid $purple;
    }

    .flag {
      @include widthPercent(43);
      @include heightPercent(32);
      border: 1px solid black;
      margin-left: 0.5vh;
    }

    .price {
      font-size: 1.3rem;
      margin-right: 0.5vh;
    }
  }

  .subtitles {
    position: absolute;
    bottom: 0px;
    font-family: "National-Medium";
    font-size: 0.9rem;
    line-height: 1rem;
  }

  .titleBloc {
    margin-left: -0.5vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/novotel/rates/horizontal/v1/right/change/change.vue